import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, Renderer2 } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { SubscriptionComponent } from '@pages/features';
import { PagesService } from '@services/pages.service';
import { SharedService } from '@services/shared.service';
import { SharedModule } from '@shared/shared.module';
import { AuthService } from 'src/app/Auth/AuthService';

@Component({
  selector: 'app-subscription-data',
  standalone: true,
  imports: [SharedModule, FormsModule, CommonModule,SubscriptionComponent],
  templateUrl: './subscription-data.component.html',
  styleUrls: ['./subcription-data.component.scss'],
})
export class SubscriptionDataComponent {
  authService = inject(AuthService);
  sharedService = inject(SharedService);
  pagesService = inject(PagesService);
  router = inject(Router);
  subscribedPlans: any;
  activeTabId: 'monthly' | 'annually' = 'monthly';
  renderer = inject(Renderer2);
  elementRef = inject(ElementRef);

  ngOnInit(): void {
    // this.markPaymentAsChecked();
    // this.getSubscribedPlans();
  }


}
